import countryToLanguageMapping from "./countryToLanguageMapping.js";
import languageCodeToName from "./languageCodeToName.js";

// Google Translate functions

export function googleTranslateElementInit2() {
    const google = window.google;
    new google.translate.TranslateElement(
        {
            pageLanguage: "en",
            autoDisplay: false,
        },
        "google_translate_element2"
    );
}

function GTranslateGetCurrentLang() {
    var keyValue = document["cookie"].match("(^|;) ?googtrans=([^;]*)(;|$)");
    return keyValue ? keyValue[2].split("/")[2] : null;
}

function GTranslateFireEvent(element, event) {
    try {
        if (document.createEventObject) {
            var evt = document.createEventObject();
            element.fireEvent("on" + event, evt);
        } else {
            var evt = document.createEvent("HTMLEvents");
            evt.initEvent(event, true, true);
            element.dispatchEvent(evt);
        }
    } catch (e) {}
}

function doGTranslate(lang_pair) {
    if (lang_pair.value) lang_pair = lang_pair.value;
    if (lang_pair == "") return;
    var lang = lang_pair.split("|")[1];
    if (GTranslateGetCurrentLang() == null && lang == lang_pair.split("|")[0])
        return;
    var teCombo;
    var sel = document.getElementsByTagName("select");
    for (var i = 0; i < sel.length; i++)
        if (sel[i].className.indexOf("goog-te-combo") != -1) {
            teCombo = sel[i];
            break;
        }
    if (
        document.getElementById("google_translate_element2") == null ||
        document.getElementById("google_translate_element2").innerHTML.length ==
            0 ||
        teCombo.length == 0 ||
        teCombo.innerHTML.length == 0
    ) {
        setTimeout(function () {
            doGTranslate(lang_pair);
        }, 500);
    } else {
        teCombo.value = lang;
        GTranslateFireEvent(teCombo, "change");
        GTranslateFireEvent(teCombo, "change");
    }
}

const gtSelect = document.querySelector(".gt__select");

export const changeOpenerLang = () => {
    const opener = document.querySelector(".header .custom-select-opener");
    const googtransValue = getCookie("googtrans");
    let openerLang;
    if (googtransValue) {
        openerLang = googtransValue
            .split("/")
            .pop()
            .toUpperCase()
            .split("-")
            .pop();
    } else {
        openerLang = "EN";
    }

    const newOpenerSpan = document.querySelector(".new-opener");
    if (newOpenerSpan) {
        newOpenerSpan.innerText = openerLang;
    } else {
        const newOpener = document.createElement("span");
        newOpener.setAttribute("class", "new-opener notranslate");
        newOpener.innerText = openerLang;
        opener.append(newOpener);
    }
};

// language select

const translateBySelect = () => {
    if (gtSelect.value === "en|en") {
        localStorage.setItem("showPromptAgain", "yes");
        showPrompt();
    } else {
        localStorage.setItem("showPromptAgain", "no");
    }
};

export const checkSelectOption = () => {
    const cstSel = document.querySelector(".customSelect").customSelect;
    const googtransVal = getCookie("googtrans");
    let googtransLang;
    googtransLang = googtransVal.split("/");
    cstSel.value = `en|${googtransLang[googtransLang.length - 1]}`;
};

gtSelect.addEventListener("change", function () {
    doGTranslate(gtSelect);
    setCookie("googtrans", `/en/${gtSelect.value.split("|").pop()}`);
    changeOpenerLang();
    translateBySelect();
    checkSelectOption();
});

// Cookies

function setCookie(cname, cvalue, domain = "www.woodplc.com") {
    document.cookie = cname + "=" + cvalue + ";" + "domain=" + domain + ";";
}

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

let visited = localStorage.getItem("visited");

function checkVisit() {
    if (!visited || visited === "false") {
        localStorage.setItem("showPromptAgain", "yes");
        localStorage.setItem("visited", "true");
    }
}
checkVisit();
// Find language for user localisation

let country;
let language;
let countryExists = "false";

const checkIfCountryExists = async (country) => {
    if (countryToLanguageMapping[country.toLowerCase()] != undefined) {
        countryExists = "false";
    }
};

const findLanguage = async () => {
    await fetch(
        "https://dxp-uk-search.funnelback.squiz.cloud/s/search.json?collection=wood~sp-meta&query=getlocationoftheuser"
    )
        .then((res) => res.json())
        .then((response) => {
            country = response.question.location.countryCode;
            checkIfCountryExists(country);
            if (countryExists === "true") {
                language = countryToLanguageMapping[country.toLowerCase()];
                console.log("Language:", language);
            }
        })
        .catch((error) => {
            console.log("Error:", error);
        });
};

// Set language

const englishSelected = () => {
    localStorage.setItem("showPromptAgain", "no");
    gtSelect.value = "en|en";
    doGTranslate(gtSelect);
    changeOpenerLang();
};

const localeLangSelected = (language) => {
    localStorage.setItem("showPromptAgain", "no");
    setCookie("googtrans", `/en/${language}`);
    gtSelect.value = `en|${language}`;
    doGTranslate(gtSelect);
    changeOpenerLang();
    checkSelectOption();
};

const showTranslateLightbox = async (language) => {
    console.log(language)
    const showPromptAgain = localStorage.getItem("showPromptAgain");
    const languagePrompt = document.createElement("div");
    languagePrompt.setAttribute("class", "auto-translate__section");
    languagePrompt.innerHTML = `
        <div class="auto-translate__wrapper">
            <p class="auto-translate__title">Language settings</p>
            <p class="auto-translate__text">Select which variant of our site you would prefer to visit today</p>
            <button class="btn btn--primary english">English</button>
            <button class="btn btn--tertiary locale-lang">${
                languageCodeToName[language]?.charAt(0).toUpperCase() +
                languageCodeToName[language]?.slice(1)
            }</button>
        <div>`;
    const container = document.querySelector(".page-wrapper");

    languageCodeToName[language] && container.append(languagePrompt);

    const prompt = document.querySelector(".auto-translate__section");

    if (
        language != "en" &&
        language != undefined &&
        showPromptAgain === "yes"
    ) {
        prompt.classList.add("visible");
    }
    const englishButton = document.querySelector(".btn.english");
    const localeLangButton = document.querySelector(".btn.locale-lang");

    englishButton &&
        englishButton.addEventListener("click", function () {
            englishSelected();
            prompt.classList.remove("visible");
        });
    localeLangButton &&
        localeLangButton.addEventListener("click", function () {
            localeLangSelected(language);
            prompt.classList.remove("visible");
        });
};
const showPrompt = async () => {
    await findLanguage();

    // If the user is on a mobile device, do not show the popup. Aligned with Matej until
    // translate dropdown gets refactored to work on mobile
    if (window.innerWidth < 1280) {
        return;
    }

    await showTranslateLightbox(language);
};

showPrompt();
